import React, { useState, useEffect } from 'react';
import { callAction } from '../lib/odoo.js';
import { LocationPicker } from './PrepLocationPicker.jsx';
export { LocationPicker };

const TYPES = [
  { id: 'autre_emplacement', label: 'Je ne trouve pas le produit à l’emplacement indiqué', desc: 'Prep te guide écran par écran, sans l’ordi', bg: '#FEF3C7', color: '#92400E' },
  { id: 'manquant', label: 'Manquant', desc: 'Pas trouvé en stock', bg: '#FDECEA', color: '#C0392B' },
  { id: 'produit_abime', label: 'Abîmé', desc: 'Emballage endommagé', bg: '#FDECEA', color: '#C0392B' },
  { id: 'ecart_moins', label: 'Écart −', desc: 'Boîtes en moins', bg: '#FDECEA', color: '#C0392B' },
  { id: 'ecart_plus', label: 'Écart +', desc: 'Boîtes en plus', bg: '#FEF3CD', color: '#7D5A0A' },
  { id: 'peremption', label: 'Péremption', desc: '≤ 6 mois', bg: '#FEF3CD', color: '#7D5A0A' },
  { id: 'mauvais_lot', label: 'Mauvais lot', desc: 'Lot incorrect', bg: '#D6EAF8', color: '#1A5276' },
  { id: 'erreur_ref', label: 'Mauvais produit', desc: 'Pas le bon reçu', bg: '#D6EAF8', color: '#1A5276' },
  { id: 'autre', label: 'Autre', desc: 'À préciser', bg: '#F0F0F0', color: '#888' },
];

const TYPE_LABELS = {
  autre_emplacement: 'Autre emplacement', changement_lot: 'Changement de lot',
  manquant: 'Manquant', produit_abime: 'Abîmé', ecart_plus: 'Écart +',
  ecart_moins: 'Écart −', peremption: 'Péremption', mauvais_lot: 'Mauvais lot',
  erreur_ref: 'Erreur réf.', autre: 'Autre',
};

const TYPE_COLORS = {
  autre_emplacement: '#1E6B3C', changement_lot: '#1A5276',
  manquant: '#C0392B', produit_abime: '#C0392B', ecart_plus: '#7D5A0A',
  ecart_moins: '#C0392B', peremption: '#7D5A0A', mauvais_lot: '#1A5276',
  erreur_ref: '#1A5276', autre: '#888',
};

export default React.memo(function PrepAnomaliesSection({
  products, anomalies, remarks,
  selectedProduct, setSelectedProduct,
  pendingAnomaly, setPendingAnomaly,
  anomFilter, setAnomFilter,
  freeRemark, setFreeRemark,
  anomScanRef,
  onSubmitAnomaly, onRemoveAnomaly,
  onSubmitRemark, onRemoveRemark,
  onPasTrouve = null,      // « Je ne trouve pas » : ouvre l'assistant plein écran (PrepAReprendre)
  orderRefs = [],
}) {
  const filteredProds = anomFilter
    ? products.filter(p => p.name.toLowerCase().includes(anomFilter.toLowerCase()))
    : products;

  return (
    <>
      {/* Scan / recherche produit */}
      <input ref={anomScanRef} className="input input-scan" type="text"
        value={anomFilter} onChange={e => { setAnomFilter(e.target.value); setSelectedProduct(null); }}
        placeholder="Bip TSL produit ou taper le nom…"
        autoFocus style={{ marginBottom: 6 }} />

      {/* Produit sélectionné → boutons type */}
      {selectedProduct && !pendingAnomaly && (
        <div style={{
          padding: 10, borderRadius: 10, background: '#EEF6FF',
          border: '1.5px solid #85B7EB', marginBottom: 8,
        }}>
          <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 2 }}>{selectedProduct.name}</div>
          <div style={{ fontSize: 10, color: '#888', marginBottom: 8 }}>Quantité commandée : {selectedProduct.total_qty}</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {TYPES.map(t => (
              <button key={t.id} onClick={() => t.id === 'autre_emplacement' && onPasTrouve ? onPasTrouve(selectedProduct) : setPendingAnomaly({ product: selectedProduct, type: t.id })} style={{
                padding: '8px 10px', borderRadius: 8, border: '1px solid ' + t.color + '44',
                background: t.bg, color: t.color, fontSize: 11, fontWeight: 600,
                cursor: 'pointer', fontFamily: 'inherit',
                flex: t.id === 'autre_emplacement' && onPasTrouve ? '1 0 100%' : '1 0 calc(50% - 2px)',
                textAlign: 'center', transition: 'transform 0.1s',
              }}>
                {t.id === 'autre_emplacement' && onPasTrouve
                  ? <><div style={{ fontSize: 13, fontWeight: 800 }}>{t.label}</div><div style={{ fontSize: 11, fontWeight: 500, marginTop: 2 }}>{t.desc}</div></>
                  : (t.id === 'autre_emplacement' ? 'Autre emplacement' : t.label)}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* "Pris à un autre emplacement" : choix dans la liste Odoo, sans caméra */}
      {pendingAnomaly && pendingAnomaly.type === 'autre_emplacement' && (
        <LocationPicker product={pendingAnomaly.product}
          onPick={(loc, lot) => onSubmitAnomaly(pendingAnomaly.product, 'autre_emplacement', true, { location: loc, lot })}
          onCancel={() => setPendingAnomaly(null)} />
      )}

      {/* Question "Produit mis dans la commande ?" */}
      {pendingAnomaly && pendingAnomaly.type !== 'autre_emplacement' && (
        <div style={{
          padding: 14, borderRadius: 10, background: '#FFF8F0',
          border: '2px solid #D4680A', marginBottom: 8,
        }}>
          <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 2 }}>{pendingAnomaly.product.name.includes(']') ? pendingAnomaly.product.name.split(']')[0] + ']' : pendingAnomaly.product.name}</div>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#D4680A', marginBottom: 10 }}>
            Produit mis dans la commande ?
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={() => { onSubmitAnomaly(pendingAnomaly.product, pendingAnomaly.type, true); }} style={{
              flex: 1, padding: 14, borderRadius: 10, border: 'none',
              background: '#1E6B3C', color: 'white', fontSize: 15, fontWeight: 700,
              cursor: 'pointer', fontFamily: 'inherit',
            }}>✅ OUI</button>
            <button onClick={() => { onSubmitAnomaly(pendingAnomaly.product, pendingAnomaly.type, false); }} style={{
              flex: 1, padding: 14, borderRadius: 10, border: 'none',
              background: '#C0392B', color: 'white', fontSize: 15, fontWeight: 700,
              cursor: 'pointer', fontFamily: 'inherit',
            }}>❌ NON</button>
          </div>
          <button onClick={() => setPendingAnomaly(null)} style={{
            width: '100%', marginTop: 6, padding: 8, borderRadius: 8,
            border: '1px solid #E2E2E8', background: 'white', color: '#888',
            fontSize: 11, cursor: 'pointer', fontFamily: 'inherit',
          }}>← Retour</button>
        </div>
      )}

      {/* Liste produits (si pas de sélection ni pending) */}
      {!selectedProduct && !pendingAnomaly && (
        <div style={{ maxHeight: 250, overflowY: 'auto', marginBottom: 8 }}>
          {filteredProds.length === 0 && anomFilter && (
            <div style={{ textAlign: 'center', padding: 16, color: '#999', fontSize: 12 }}>
              Aucun produit pour « {anomFilter} »
            </div>
          )}
          {filteredProds.map(p => (
            <div key={p.id} onClick={() => setSelectedProduct(p)} style={{
              display: 'flex', alignItems: 'center', gap: 8, padding: '9px 10px',
              border: '1px solid #E8E8EE', borderRadius: 8, marginBottom: 3,
              cursor: 'pointer', background: 'white', transition: 'background 0.1s',
            }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.name}</div>
              </div>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#1A5276', flexShrink: 0 }}>x{p.total_qty}</div>
            </div>
          ))}
        </div>
      )}

      <div className="sep"></div>

      {/* Anomalies déjà signalées */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
        <div className="section-title" style={{ margin: 0 }}>Signalements ({anomalies.length})</div>
      </div>

      {anomalies.length === 0 && (
        <div style={{ textAlign: 'center', padding: 12, color: '#BBB', fontSize: 12 }}>Aucune anomalie signalée</div>
      )}

      {anomalies.map(a => {
        const time = a.declared_at ? new Date(a.declared_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : '';
        const who = a.declared_by_user?.name || '?';
        const typeColor = TYPE_COLORS[a.anomaly_type] || '#C0392B';
        return (
          <div key={a.id} style={{
            padding: 12, borderRadius: 12, marginBottom: 8,
            background: 'white', border: '2px solid ' + typeColor + '44',
          }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#18181A', marginBottom: 4, lineHeight: 1.3 }}>
              {a.product_name || 'Produit inconnu'}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
              <span style={{
                fontSize: 12, fontWeight: 700, padding: '4px 10px', borderRadius: 6,
                background: typeColor + '18', color: typeColor,
              }}>
                {TYPE_LABELS[a.anomaly_type] || a.anomaly_type}
              </span>
              {a.product_included === true && <span style={{ fontSize: 10, fontWeight: 700, padding: '3px 8px', borderRadius: 5, background: '#D5F5E3', color: '#1E6B3C' }}>✅ Mis</span>}
              {a.product_included === false && <span style={{ fontSize: 10, fontWeight: 700, padding: '3px 8px', borderRadius: 5, background: '#FDECEA', color: '#C0392B' }}>❌ Non mis</span>}
              <span style={{ fontSize: 11, color: '#999' }}>{who} — {time}</span>
            </div>
            <button onClick={() => onRemoveAnomaly(a.id)} style={{
              width: '100%', padding: 10, borderRadius: 8,
              border: '1.5px solid #C0392B', background: '#FDECEA',
              color: '#C0392B', fontSize: 13, fontWeight: 700,
              cursor: 'pointer', fontFamily: 'inherit',
            }}>🗑 Supprimer cette anomalie</button>
          </div>
        );
      })}

      <div className="sep"></div>

      {/* Remarques libres */}
      <div className="section-title">Remarque libre</div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
        <input className="input" type="text" value={freeRemark}
          onChange={e => setFreeRemark(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && onSubmitRemark()}
          placeholder="Ex: palette mal rangée, frigo temp…"
          style={{ flex: 1, fontSize: 13 }} />
        <button onClick={onSubmitRemark} style={{
          padding: '10px 16px', borderRadius: 8, border: 'none',
          background: '#18181A', color: 'white', fontSize: 13, fontWeight: 600,
          cursor: 'pointer', fontFamily: 'inherit', flexShrink: 0,
        }}>Envoyer</button>
      </div>

      {remarks.length > 0 && (
        <div>
          {remarks.map(r => {
            const time = r.declared_at ? new Date(r.declared_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : '';
            const who = r.declared_by_user?.name || '?';
            return (
              <div key={r.id} style={{
                padding: '10px 12px', borderRadius: 10, marginBottom: 6,
                background: '#FEF3CD', border: '1.5px solid #F0C41966',
              }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#7D5A0A', marginBottom: 6 }}>{r.text}</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: 11, color: '#999' }}>{who} — {time}</span>
                  <button onClick={() => onRemoveRemark(r.id)} style={{
                    padding: '6px 14px', borderRadius: 6,
                    border: '1.5px solid #7D5A0A', background: 'white',
                    color: '#7D5A0A', fontSize: 12, fontWeight: 700,
                    cursor: 'pointer', fontFamily: 'inherit',
                  }}>🗑 Supprimer</button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
});
